import type {Components, Theme} from '@mui/material/styles';

/** Opt-in class: track uses `color` prop; bar uses `success.dark` with a square leading edge. */
export const LINEAR_PROGRESS_COLORED_TRACK_CLASS = 'MithraLinearProgress-coloredTrack';

export const linearProgressOverrides: Components<Theme>['MuiLinearProgress'] = {
    styleOverrides: {
        root: ({theme}) => ({
            height: 6,
            borderRadius: theme.spacing(1),
            // Unfilled / total track — always grey.100 (including color variants)
            backgroundColor: theme.palette.grey[100],
            '&.MuiLinearProgress-colorPrimary, &.MuiLinearProgress-colorSecondary, &.MuiLinearProgress-colorError, &.MuiLinearProgress-colorInfo, &.MuiLinearProgress-colorSuccess, &.MuiLinearProgress-colorWarning, &.MuiLinearProgress-colorInherit': {
                backgroundColor: theme.palette.grey[100],
            },
            [`&.${LINEAR_PROGRESS_COLORED_TRACK_CLASS}`]: {
                overflow: 'hidden',
                backgroundColor: theme.palette.grey[100],
                '&.MuiLinearProgress-colorPrimary, &.MuiLinearProgress-colorSecondary, &.MuiLinearProgress-colorError, &.MuiLinearProgress-colorInfo, &.MuiLinearProgress-colorSuccess, &.MuiLinearProgress-colorWarning, &.MuiLinearProgress-colorInherit': {
                    backgroundColor: theme.palette.grey[100],
                },
                '& .MuiLinearProgress-bar': {
                    backgroundColor: theme.palette.success.dark,
                    // Square leading edge ("not curved inside"); outer curve from root + overflow.
                    borderRadius: 0,
                },
            },
        }),
        bar: ({theme}) => ({
            borderRadius: theme.spacing(1),
        }),
    },
};
